import { createSelector } from 'reselect';
import sortBy from 'lodash/sortBy';
import filter from 'lodash/filter';


const getHotkeyTmpState = createSelector(
  [
    (state) => state.hotkey_template
  ],
  (state) => state
);


export const getChildrenState = createSelector(
  [
    getHotkeyTmpState
  ],
  (state) => state.children || {}
);


export const getTabChildrenState = createSelector(
  [
    (state, tabKey) => tabKey,
    (state, tabKey) => getChildrenState(state)
  ],
  (tabKey, children) => children[tabKey] || {}
);


export const getTabChildren = createSelector(
  [
    getTabChildrenState
  ],
  (tabChildState) => tabChildState.items || []
);


export const getTabSortedChildren = createSelector(
  [
    getTabChildren
  ],
  (items) => sortBy(items, ['position']) || []
);


export const getTabChildrenGroup = createSelector(
  [
    getTabSortedChildren
  ],
  (items) => filter(items, { is_group: true })
);


export const getTabChildrenItem = createSelector(
  [
    getTabSortedChildren
  ],
  (items) => filter(items, { is_group: false })
);
